/**
 * @generated SignedSource<<cb17c4389869d25f8974e659f3236c55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavItem_notifications$data = {
  readonly listings: number | null;
  readonly messages: number | null;
  readonly orders: number | null;
  readonly " $fragmentType": "NavItem_notifications";
};
export type NavItem_notifications$key = {
  readonly " $data"?: NavItem_notifications$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavItem_notifications">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavItem_notifications",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "listings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orders",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messages",
      "storageKey": null
    }
  ],
  "type": "DealerNavBarBadges",
  "abstractKey": null
};

(node as any).hash = "43ca1a9510a88df04eda29bd31577f39";

export default node;
